export async function inertiaLite(url, params = {}) {

    let headers = {
        'content-type': 'application/json',
        'X-Inertia': true,
        'X-Requested-With': 'XMLHttpRequest'
    };

    if (params.component) {
        headers['X-Inertia-Partial-Component'] = params.component;
    }

    if (params.only) {
        headers['X-Inertia-Partial-Data'] = params.only.join(',');
    }

    let request = new Request(url, {
        headers: headers
    });

    let response = await fetch(request);
    return await response.json();

}

export function quickCustomEvent(handle, detail) {
    let e = new CustomEvent(handle, {
        detail: detail
    });
    window.dispatchEvent(e);
}

export async function scrollToId(id, speed = 600) {
    let target = window.jQuery('#' + id);
    if (!target.length) {
        return Promise.resolve();
    }
    window.jQuery('html,body').animate({
        scrollTop: target.offset().top
    }, speed);

    return new Promise(resolve => {
        window.setTimeout(resolve, speed + 10);
    });

}
